import _slicedToArray from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var MSEC_IN_HOUR = 60 * 60 * 1000; //convert our local date syntax a javascript UTC date

var toUtc = function toUtc(dstChange, offset, year) {
  var _dstChange$split = dstChange.split('/'),
      _dstChange$split2 = _slicedToArray(_dstChange$split, 2),
      month = _dstChange$split2[0],
      rest = _dstChange$split2[1];

  var _rest$split = rest.split(':'),
      _rest$split2 = _slicedToArray(_rest$split, 2),
      day = _rest$split2[0],
      hour = _rest$split2[1];

  return Date.UTC(year, month - 1, day, hour) - offset * MSEC_IN_HOUR;
}; // compare epoch with dst change events (in utc)


var inSummerTime = function inSummerTime(epoch, start, end, summerOffset, winterOffset) {
  var year = new Date(epoch).getUTCFullYear();
  var startUtc = toUtc(start, winterOffset, year);
  var endUtc = toUtc(end, summerOffset, year); // simple number comparison now

  return epoch >= startUtc && epoch < endUtc;
};

export default inSummerTime;